import React, { useState } from "react";
import { useEffect, useRef } from "react";
//
import Web3Modal from "web3modal";
import WalletConnectProvider from "@walletconnect/web3-provider";
import WalletLink from "walletlink";
import Web3 from "web3";
import { ethers } from "ethers";
//
import nftabi from "./nftabi.json";
import nftstakeabi from "./nftstakeabi.json";
import TOKENABI from "./TOKENABI.json";
import TokenStakeABI from "./TokenStakeABI.json";
import lockedStakeContractABI from "./lockedStakeContract.json";
import lockedStakeTokenABI from "./lockedStakeTokenABI.json";

export const BlockchainContext = React.createContext("");

var web3 = null;
var account = null;
var contract = null;
var ADDRESS = "0xe4216750691101Caf932E5abad2f959A9000f130"; // nft
var nftADDRESS = "0xdc2E0669B415d0D9FF0ac89E1E2df1255514F062"; // staking nft
let nftStakeContract = null;
const address = ADDRESS;
const abi = nftabi;
var provider = null;
var tokencontract = null;
var TokenStake = null;
var tokencontract1 = "0x813D435c321f2497437363A6aaB7972c9eb74438";
var TokenStake1 = "0xB8Be8faf3faaCBe3419b27bD4973f4206EFCD096";
const nftStakeAddress = nftADDRESS;
const nftabistake = nftstakeabi;

let lockedStakeToken = null;
let lockedStakeContract = null;
let lockedStakeTokenAddress = "0xd42C128431bB1a08Ad6CC3FFdE788151A858e4f6";
let lockedStakeContractAddress = "0xB34162a8D233593F53F747F3797636B0A0682835";

export const BlockchainProvider = ({ children }) => {
  const [currentAccount, setCurrentAccount] = useState("");
  // WC

  const providerOptions = {
    binancechainwallet: {
      package: true,
    },
    walletconnect: {
      package: WalletConnectProvider,
      options: {
        infuraId: "2bb8830b4a274fda97f4743863b897bb",
      },
    },
    walletlink: {
      package: WalletLink,
      options: {
        appName: "Net2Dev NFT Minter",
        infuraId: "2bb8830b4a274fda97f4743863b897bb",
        rpc: "",
        chainId: 56,
        appLogoUrl: null,
        darkMode: true,
      },
    },
  };
  const web3Modal = new Web3Modal({
    chainId: 56,
    network: "mainnet",
    theme: "dark",
    cacheProvider: true,
    providerOptions,
  });

  async function connectWallet() {
    var provider = await web3Modal.connect();
    var web3 = new Web3(provider);
    var accounts = await web3.eth.getAccounts();
    account = accounts[0];
    delay();
    lockedStakeContract = new web3.eth.Contract(
      lockedStakeContractABI,
      lockedStakeContractAddress
    );
    delay();

    lockedStakeToken = new web3.eth.Contract(
      lockedStakeTokenABI,
      lockedStakeTokenAddress
    );
    delay();

    contract = new web3.eth.Contract(abi, address);
    nftStakeContract = new web3.eth.Contract(nftabistake, nftStakeAddress);
    tokencontract = new web3.eth.Contract(TOKENABI, tokencontract1);
    TokenStake = new web3.eth.Contract(TokenStakeABI, TokenStake1);
    console.log(accounts[0]);
    setCurrentAccount(accounts[0]);

    // Data Locked Token Stake

    var rewardBalance = await lockedStakeToken.methods
      .balanceOf("0xb34162a8d233593f53f747f3797636b0a0682835")
      .call();
    document.getElementById("rewardBalance").textContent = (
      rewardBalance / 1000000000
    ).toFixed(2);

    let lockedAPR = (await lockedStakeContract.methods.apy().call()) + " %";
    document.getElementById("lockedAPR").textContent = lockedAPR;
    var tokenBalance = await lockedStakeToken.methods.balanceOf(account).call();
    document.getElementById("LockedTokenBalance").textContent = (
      tokenBalance / 1000000000
    ).toFixed(2);

    var userStaked = await lockedStakeContract.methods.userInfo(account).call();
    document.getElementById("userLocked").textContent = (
      userStaked[0] / 1000000000
    ).toFixed(2);

    let lockedPendingRewards = await lockedStakeContract.methods
      .pendingReward(account)
      .call();
    document.getElementById("lockedPendingRewards").textContent =
      lockedPendingRewards / 1000000000;

    // unlock date function
    let holderUnlockTime = await lockedStakeContract.methods
      .holderUnlockTime(account)
      .call();
    let UnlockTime = new Date(holderUnlockTime * 1000);
    let unlockDay = UnlockTime.toGMTString();
    document.getElementById("holderUnlockTime").textContent = unlockDay;

    // end

    let totalLockedStake = await lockedStakeContract.methods
      .totalStaked()
      .call();
    document.getElementById("totalLockedStake").textContent =
      totalLockedStake / 1000000000;
    let exitPenaltyPerc =
      (await lockedStakeContract.methods.exitPenaltyPerc().call()) + " %";
    document.getElementById("exitPenaltyPerc").textContent = exitPenaltyPerc;

    // Data Unlocked TokenStake

    let pendingRewards = await TokenStake.methods.pendingReward(account).call();
    document.getElementById("pendingRewards").textContent =
      pendingRewards / 1000000000;

    var rawnfts = await TokenStake.methods.userInfo(account).call();
    document.getElementById("depositedTokens").textContent = (
      rawnfts[0] / 1000000000
    ).toFixed(2);
    var rawnfts = await TokenStake.methods.stakedSupply().call();
    document.getElementById("StakedTokens").textContent = (
      rawnfts / 1000000000
    ).toFixed(2);
    var rawnfts = await tokencontract.methods.balanceOf(account).call();
    document.getElementById("balance").textContent = (
      rawnfts / 1000000000
    ).toFixed(2);
    let totalStaked_ = await TokenStake.methods.stakedSupply().call();
    let totalStakedV = totalStaked_ / 1000000000;
    let rewardPerYear = await TokenStake.methods.rewardPerBlock().call();
    let rewardPerYear_ = (rewardPerYear / 1e9) * 28800 * 365;
    let finalValue = totalStakedV + rewardPerYear_;
    let startingValue = totalStakedV;
    let totalAPY =
      ((finalValue - startingValue) / startingValue).toFixed(2) * 100 + " %";
    document.getElementById("APR").textContent = totalAPY;

    // Grab Data NFTS
    let balanceOf = await contract.methods.balanceOf(account).call();
    document.getElementById("balanceOfNFT").textContent = balanceOf;

    let totalSupply_ = await contract.methods.totalSupply().call();
    document.getElementById("totalSupply").textContent = totalSupply_;
    console.log(`value = ${totalSupply_}`);
    let maxSupply_ = await contract.methods.maxSupply().call();
    document.getElementById("maxSupply").textContent = maxSupply_;
    console.log(`value = ${maxSupply_}`);
    let cost = await contract.methods.cost().call();
    let formatCost = ethers.utils.formatEther(cost) * 1000;
    document.getElementById("costofmint").textContent = formatCost;
    console.log(`value = ${formatCost}`);

    let totalstakednfts = await nftStakeContract.methods.tokensStaked().call();
    document.getElementById("totalnftstaked").textContent = totalstakednfts;
    console.log(`value = ${totalstakednfts}`);
    let getstakednfts = await nftStakeContract.methods
      .depositsOf(account)
      .call();
    document.getElementById("getstakednfts").textContent = getstakednfts;
    console.log(`value = ${getstakednfts}`);

    var rawnfts = await nftStakeContract.methods.depositsOf(account).call();
    const arraynft = Array.from(rawnfts.map(Number));
    const tokenid = arraynft.filter(Number);
    var rwdArray = [];
    tokenid.forEach(async (id) => {
      var rawearn = await nftStakeContract.methods
        .calculateRewards(account, [id])
        .call();
      var array = Array.from(rawearn.map(Number));
      array.forEach(async (item) => {
        var earned = String(item).split(",")[0];
        var earnedrwd = earned;
        var rewardx = Number(earnedrwd).toFixed(18);
        var numrwd = Number(rewardx);
        rwdArray.push(numrwd);
      });
    });

    // END of connect wallet function

    // setInterval(connectWallet, 10000);

    async function delay() {
      return new Promise((resolve) => setTimeout(resolve, 300));
    }

    async function delayedLog(item) {
      await delay();
      var sum = item.reduce((a, b) => a + b, 0);
      var formatsum = Number(sum).toFixed(18);
      document.getElementById("earned").textContent = Math.round(
        formatsum / 1000000000
      );
      Math.round(formatsum);
    }
    async function processArray(rwdArray) {
      for (const item of rwdArray) {
        await delayedLog(item);
      }
    }
    return processArray([rwdArray]);
  }
  async function approve() {
    contract.methods.setApprovalForAll(nftADDRESS, true).send({
      to: contract,
      from: account,
    });
  }

  const checkifWalletIsConnected = async () => {
    try {
      const accounts = await provider.send("eth_accounts");
      if (accounts.length) {
        setCurrentAccount(accounts[0]);
      } else {
        console.log("No accounts found");
      }
    } catch (error) {
      console.log("error");
    }
  };
  // Minting Functions Read
  const maxMint = async () => {
    let maxMint_ = await contract.methods.maxMintAmount().call();
    // document.getElementById("maxMint").textContent = maxMint_;
    console.log(`value = ${maxMint_}`);
  };
  const totalSupply = async () => {
    let totalSupply_ = await contract.methods.totalSupply().call();
    document.getElementById("totalSupply").textContent = totalSupply_;
    console.log(`value = ${totalSupply_}`);
  };
  const maxSupply = async () => {
    let maxSupply_ = await contract.methods.maxSupply().call();
    document.getElementById("maxSupply").textContent = maxSupply_;
    console.log(`value = ${maxSupply_}`);
  };
  const mintCost = async () => {
    let cost = await contract.methods.cost().call();
    let formatCost = ethers.utils.formatEther(cost) * 1000;
    document.getElementById("costofmint").textContent = formatCost;
    console.log(`value = ${formatCost}`);
  };

  const approveStake = async () => {
    await tokencontract.methods
      .approve(
        "0xB8Be8faf3faaCBe3419b27bD4973f4206EFCD096",
        "100000000000000000000000000000"
      )
      .send({
        to: tokencontract,
        from: account,
      });
    //   document.getElementById("hasApproved").textContent = hasApproved;
    // console.log(`value = ${hasApproved}`);
  };
  // Minting Functions Send

  async function mintNFTone() {
    let totalCostWei = String("100000000000");
    let mintAmount = String("1");
    let totalGasLimit = String("210000");

    contract.methods.mint(mintAmount).send({
      gasLimit: String(totalGasLimit),
      to: contract,
      from: account,
      value: totalCostWei,
    });
  }

  // nft stake read
  async function grabNFTStakeData() {
    let totalstakednfts = await nftStakeContract.methods.tokensStaked().call();
    document.getElementById("totalnftstaked").textContent = totalstakednfts;
    console.log(`value = ${totalstakednfts}`);
    let getstakednfts = await nftStakeContract.methods
      .depositsOf(account)
      .call();
    document.getElementById("getstakednfts").textContent = getstakednfts;
    console.log(`value = ${getstakednfts}`);

    var rawnfts = await nftStakeContract.methods.depositsOf(account).call();
    const arraynft = Array.from(rawnfts.map(Number));
    const tokenid = arraynft.filter(Number);
    var rwdArray = [];
    tokenid.forEach(async (id) => {
      var rawearn = await nftStakeContract.methods
        .calculateRewards(account, [id])
        .call();
      var array = Array.from(rawearn.map(Number));
      array.forEach(async (item) => {
        var earned = String(item).split(",")[0];
        var earnedrwd = earned;
        var rewardx = Number(earnedrwd).toFixed(18);
        var numrwd = Number(rewardx);
        rwdArray.push(numrwd);
      });
    });
    async function delay() {
      return new Promise((resolve) => setTimeout(resolve, 300));
    }
    async function delayedLog(item) {
      await delay();
      var sum = item.reduce((a, b) => a + b, 0);
      var formatsum = Number(sum).toFixed(18);
      document.getElementById("earned").textContent = Math.round(
        formatsum / 1000000000
      );
      Math.round(formatsum);
    }
    async function processArray(rwdArray) {
      for (const item of rwdArray) {
        await delayedLog(item);
      }
    }
    return processArray([rwdArray]);
  }

  //nft stake write
  async function StakeAll() {
    contract.methods
      .walletOfOwner(account)
      .call({
        to: contract,

        from: account,
      })
      .then((receipt) => {
        let TokenidofUser = receipt;
        nftStakeContract.methods
          .deposit(TokenidofUser)
          .send({
            to: nftStakeContract,
            from: account,
          })
          .then((receipt) => {
            console.log(receipt);
          });
      });
  }

  async function unstakeall() {
    var rawnfts = await nftStakeContract.methods
      .depositsOf(account)
      .call()
      .then((receipt) => {
        let TID = receipt;
        nftStakeContract.methods
          .withdraw(TID)
          .send({
            to: nftStakeContract,
            from: account,
          })
          .once("error", (err) => {
            console.log(err);
          })
          .then((receipt) => {
            console.log(receipt);
          });
      });
  }
  async function claimit() {
    var rawnfts = await nftStakeContract.methods.depositsOf(account).call();
    const arraynft = Array.from(rawnfts.map(Number));
    const tokenid = arraynft.filter(Number);
    tokenid.forEach(async (id) => {
      await nftStakeContract.methods.claimRewards([id]).send({
        to: nftStakeContract,

        from: account,
      });
    });
  }
  const depositRef = useRef();
  let depositFinal = null;

  function onDeposit(e) {
    e.preventDefault();
    console.log(depositRef.current.value);
  }

  async function depositTokens() {
    await TokenStake.methods
      .deposit(depositRef.current.value * 1000000000)
      .send({
        // confirmed 9000
        to: TokenStake,
        from: account,
      });
  }
  const withdrawRef = useRef();

  function onWithDraw(e) {
    e.preventDefault();
  }

  async function withdrawTokens() {
    await TokenStake.methods
      .withdraw(withdrawRef.current.value * 1000000000)
      .send({
        // confirmed 9000
        to: TokenStake,
        from: account,
      });
  }

  async function claimToken() {
    await TokenStake.methods.withdraw("1000000").send({
      // confirmed 9000
      to: TokenStake,
      from: account,
    });
  }
  // locked staking functions
  const approveLockedStake = async () => {
    await lockedStakeToken.methods
      .approve(lockedStakeContractAddress, "100000000000000000000000000000")
      .send({
        to: lockedStakeToken,
        from: account,
      });
  };

  async function depositLockedTokens() {
    await lockedStakeContract.methods
      .deposit(depositRef.current.value * 1000000000)
      .send({
        to: lockedStakeContract,
        from: account,
      });
  }

  async function withdrawLockedTokens() {
    await lockedStakeContract.methods
      .withdraw(/*withdrawRef.current.value * 1000000000*/)
      .send({
        // confirmed 9000
        to: lockedStakeContract,
        from: account,
      });
  }
  async function withdrawLockedRewards() {
    await lockedStakeContract.methods
      .emergencyRewardWithdraw(withdrawRef.current.value * 1000000000)
      .send({
        // confirmed 9000
        to: lockedStakeContract,
        from: account,
      });
  }
  async function emergencyWithdraw() {
    lockedStakeContract.methods.emergencyWithdraw().send({
      // confirmed 9000
      to: lockedStakeContract,
      from: account,
    });
  }
  const [mintAmount, setMintAmount] = useState(1);
  const incrementMintAmount = () => {
    setMintAmount(mintAmount + 1);
  };
  const decrementMintAmount = () => {
    setMintAmount(mintAmount - 1);
  };

  async function mintNFT() {
    let totalCostWei = String("100000000000000000");
    let totalGasLimit = String("210000");

    contract.methods.mint(mintAmount).send({
      gasLimit: String(totalGasLimit),
      value: totalCostWei * mintAmount,

      to: contract,
      from: account,
    });
  }

  useEffect(() => {
    /*   grabNFTStakeData();
    maxSupply();
    totalSupply();
    mintCost();
    checkifWalletIsConnected(); */
  }, []);
  return (
    <BlockchainContext.Provider
      value={{
        incrementMintAmount,
        decrementMintAmount,
        mintAmount,
        mintNFT,
        withdrawLockedRewards,
        emergencyWithdraw,
        withdrawLockedTokens,
        depositLockedTokens,
        approveLockedStake,
        claimToken,
        withdrawTokens,
        onWithDraw,
        withdrawRef,
        depositRef,
        useRef,
        onDeposit,
        depositTokens,
        approve,
        unstakeall,
        claimit,
        StakeAll,
        grabNFTStakeData,
        maxSupply,
        mintNFTone,
        totalSupply,
        connectWallet,
        currentAccount,
        mintCost,
        approveStake,
        maxMint,
      }}
    >
      {children}
    </BlockchainContext.Provider>
  );
};
